import type { VariantProps } from 'class-variance-authority';
import type { PropsWithChildren } from 'react';
import { cva } from 'class-variance-authority';

import { cn } from '@/utils/cn';

const badgeVariant = cva(
  'right-1.5 overflow-hidden rounded-full bg-c900 font-semibold uppercase text-main-pending',
  {
    variants: {
      variant: {
        mobile: 'px-1.5 py-1 text-[0.625rem] leading-2.5 gm-status-current-shadow gm-status-current-border',
        desktop: 'flex h-7 items-center justify-center px-2 text-xs leading-4.5 gm-status-current-shadow gm-status-current-border',
        glass: 'flex min-w-7 items-center justify-center gap-[0.313rem] py-0.5 pl-2.5 pr-2 text-xs font-medium text-light glass-wrapper-border bg-[rgba(182,140,216,0.1)]!',
      },
    },
    defaultVariants: {
      variant: 'mobile',
    },
  },
);

interface GmBadgeProps extends PropsWithChildren, VariantProps<typeof badgeVariant> {
  className?: string;
}

export const GmBadge = ({ className, children, variant }: GmBadgeProps) => {
  return (
    <div className={cn(badgeVariant({ variant }), className)}>
      {children}
    </div>
  );
};
